import { useState } from 'react'
import { HStack, Text, IconButton } from '@chakra-ui/react'
import { Eye, EyeOff, Copy } from 'lucide-react'
import { PasswordRevealProps } from '@/utils/types'
import { toaster } from '~/toaster'

export default function PasswordReveal(props: PasswordRevealProps) {
  const [reveal, setReveal] = useState(false)

  const handleClick = () => {
    setReveal(!reveal)
  }

  const copyToClipboard = () => {
    try {
      toaster.success({
        title: 'Copied to clipboard',
        duration: 3000,
      })
      navigator.clipboard.writeText(props.password)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <HStack gap={2} align="center">
      <Text fontSize="sm">
        <Text as="span" fontWeight="medium">
          Password:
        </Text>{' '}
        {reveal ? props.password : '••••••••••••'}
      </Text>
      <IconButton
        aria-label={reveal ? 'Hide password' : 'Show password'}
        size="xs"
        variant="ghost"
        onClick={handleClick}
      >
        {reveal ? <EyeOff size={16} /> : <Eye size={16} />}
      </IconButton>
      <IconButton aria-label="Copy password" size="xs" variant="ghost" onClick={copyToClipboard}>
        <Copy size={16} />
      </IconButton>
    </HStack>
  )
}
